import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Gallery } from '../api/types';

interface GalleryCardProps {
  gallery: Gallery;
  onClick: (gallery: Gallery) => void;
}

export const GalleryCard: React.FC<GalleryCardProps> = ({ gallery, onClick }) => {
  return (
    <Card 
      className="cursor-pointer hover:shadow-md transition-shadow"
      onClick={() => onClick(gallery)}
    >
      <CardHeader>
        <CardTitle className="text-lg">{gallery.name}</CardTitle>
        <CardDescription>{gallery.description}</CardDescription>
      </CardHeader>
      <CardContent>
        <p className="text-sm text-muted-foreground">
          Created: {new Date(gallery.createdDate).toLocaleDateString()}
        </p>
      </CardContent>
    </Card>
  );
};
